import axios from 'axios';
import config from '@/config/constants';

export async function requestDataExport() {
  const res = await axios.post(config.api_url + 'user/me/export-data');
  if (!res || !res.data || res.data.code !== 'SUCCESS') {
    throw new Error('Could not start export');
  }
  return res.data.data;
}

export async function getDataExportStatus(jobId) {
  const res = await axios.get(config.api_url + 'user/me/export-data/' + encodeURIComponent(jobId));
  if (!res || !res.data || res.data.code !== 'SUCCESS') {
    throw new Error('Could not load export status');
  }
  return res.data.data;
}
